export default __webpack_public_path__ + "assets/models/d4c5bdcf2e70116611af889d7387324b.glb";